const translation = {
  offRules: 'Ametlikud Reeglid',
  // Navigation pages
  play: 'MÄNGI',
  recent: 'Hiljuti',
  howToPlay: 'KUIDAS MÄNGIDA',

  // Card
  signUp: 'MÄNGIMISEKS REGISTREERI',
  viewMy: 'VAATA ENDA KAARTI',
  view: 'VAATA KAARTI',
  registered: 'REGISTREERITUD',
  entry: 'Osaleja',
  entries: 'Osalejad',
  contestClosed: 'BINGO VÕISTLUS ON SULETUD',
  ifNecessary: 'KUI ON VAJALIK',

  //Signup modal
  reg: 'Oled registreeritud mängima OlyBeti Bingot',
  rel: 'Sinu Bingo kaardi avaldamiseni on jäänud:',
  come: 'Enda kaardi nägemiseks tule tagasi mängu alguseks',
  priz: 'Auhinnad',
  regen: 'BINGO KAARTI UUENDATAKSE MÄNGU JOOKSUL AUTOMAATSELT.',
  //Wait modal
  hangTight: 'PÜSI MEIEGA!',
  cardToBeGenerated: 'Oodake BINGO KAARDI LOOMIST.',
  mayTakeUpFewMinutes: 'SEE VÕTAB AEGA KUNI MÕNI MINUT',

  // How to play page
  vert: 'VERTIKAAL',
  horiz: 'HORISONTAAL',
  diag: 'DIAGONAAL',
  fullCard: 'KOGU KAART',
  earnEntriesIntoDraw:
    'AUHINDU TEENID TERVE REA, DIAGONAALI VÕI KOGU KAARDI TÄIS SAAMISE EEST. RUUT MÄRGITAKSE TABATUKS RUUDUS MÄRGITUD SÜNDMUSE MÄNGUS ASET LEIDMISEL.',
  autoScoresDuringGame: 'BINGO KAARTI UUENDATAKSE MÄNGU JOOKSUL AUTOMAATSELT.',
  clickForMoreInfo: 'Lisainformatsiooni jaoks kliki',
  SOG: 'SOG - Vise väravale (iga vise loeb mis läheb väravaraamide vahele. Ei sisalda blokeeritud viskeid või posti tabatud viskeid)',
  PPG: 'PPG - Power play värav (värav, mis skooritakse enamuses mängiva tiimi poolt. Näiteks, kui tiim mängib 5v4, 5v3 või 4v3 enamuses)',
  SHG: 'SHG - Vähemuses skooritud värav (värav, mis skooritakse karistust kandva tiimi poolt)',
  PIM: 'PIM - Karistused kokku minutites',
  FOPercent: 'FO% - Lahtivisete võitmise protsent',
  PTS: 'PTS - Punktid (värav või resultatiivne sööt)',
  entryPerRow: 'OSALEJA REA KOHTA',
  totalEntries: 'OSALEJAID KOKKU',
  perRow: 'REA KOHTA',

  //Home page
  bingoMayTakeUp:
    'Bingo kaardite tulemuste kinnitamiseks võib kuluda kuni 20 minutit alates mängu lõpust',
  welcomeTo: 'Tere tulemast BingOlysse!',
  reviewInRecent: 'Vaata enda viimaseid kaarte "Hiljuti" vaate alt',
  thanksForPlaying:
    'Täname mängimast OlyBeti Bingot! Vaata enda 2022-2023 hooaja kaarte "Hiljuti" vaate alt',
  agreeToRules: 'Registreerudes nõustud ja oled teadlik',

  //Recent page
  noRecentContests: 'Hiljutisi võistlusi ei ole',
  //Game field page
  gamePrizeText:
    'Võida €100 Freebet, kui sinu kaardil täituvad kõik ruudud, või €5 Freebet, kui saad vähemalt ühe rea või diagonaali. Auhindu jagatakse tööpäevadel.',
  cardUpdateAfterPeriod: 'Kaart uueneb iga 30 minuti järel',
  anyLine: 'MISTAHES LIIN',
  vertLines: 'VERTIKAALSED LIINID',
  line: 'LIIN',
  horzLines: 'HORISONTAALSED LIINID',

  //Onboarding page
  letsGetStarted: 'Alustame',
  makeSureToEnterSelections:
    'Päevaauhindade eest võistlemiseks sisesta enda valikud iga päev. Pea meeles sisestada valik ka viigimurdja küsimusele. Saad muuta enda valikuid enne mängu algust. Punkte teenid iga õige ennustuse eest.',
  playWithFriends:
    'Mängi koos sõpradega. Kes on parim? Pane sõbrad proovile mängides privaatses liigas. Mine edetabeli sektsiooni, vajuta "Loo" nupule ja jaga PIN koodi sõpradele liitumiseks.',
  scoring: 'Punktiarvestus',
  challengeFriends: 'Pane sõbrad proovile',
  skip: 'jäta vahele',
  next: 'järgmine',

  logout: 'Logi välja',
  returnToGamezone: 'Mine tagasi Mängutsooni',
  rules: 'REEGLID',
  back: 'Tagasi',

  bingo: 'BingOly',
  gamezone: 'Mängutsoon',
  justAFewMinutes: 'Ainult mõned minutid, palun värskenda lehte',
  fourCorners: 'NELI NURKA',
  rulesNotFound: 'Reegleid ei leitud',
  offWebsiteText:
    'PÕHILISE TULEMUSTE OTSUSTAMISE ALLIKANA KASUTATAKSE SÜNDMUSE AMETLIKKU VEEBILEHTE. AMETLIKU VEEBILEHE PUUDUMISEL VÕTAME ARVESSE TEISI USALDUSVÄÄRSEID ALLIKAID.',
  accountInfo: 'Konto info',
  availableGames: 'Saadaval olevad mängud',
  backToOlybet: 'Tagasi OlyBetti',
  confirmNewPassword: 'Kinnita uus parool',
  confirmNewPasswordIsRequired: 'Kinnita uus parool on kohustuslik väli',
  confirmPassword: 'Kinnita parool',
  confirmPasswordIsRequired: 'Confirm Password is a required field',
  contactNumber: 'Kontaktnumber',
  country: 'Elukohariik',
  countryIsRequired: 'Riik on kohustuslik väli',
  days: 'Päeva',
  didNotMeanToUnsubscribe: 'Ei soovi ikkagi end listist eemaldada?',
  email: 'E-mail',
  emailAddressAlreadyInUse: 'Emaili aadress on juba kasutusel',
  emailIsRequired: 'Email on kohustuslik väli',
  emailOrUsername: 'E-mail või kasutajanimi',
  emailOrUsernameIsRequired: 'Email või kasutajanimi on kohustuslik väli',
  enterYourDetails: 'Palun sisesta oma andmed',
  enterYourEmail: 'Sisesta e-mail, et parool taastada',
  errorDuringLogin: 'Viga sisse logimisel',
  errorDuringRegistration: 'Viga registreerimisel',
  errorDuringSubscribing: 'Error during subscribing',
  errorDuringUnsubscribing: 'Viga maharegistreerimisel',
  errorUpdatingProfile: 'Viga profiili uuendamisel',
  firstName: 'Eesnimi',
  firstNameIsRequired: 'Eesnimi on kohustuslik väli',
  firstNameMusBeAtLeast: 'Eesnimi peab sisaldama vähemalt kolme tähemärki',
  firstNameMustNotExceed: 'Eesnimi ei tohi ületada sadat tähemärki',
  forgotPassword: 'Unustasin parooli',
  full: 'TÄIS',
  gameDetails: 'Mängudetailid',
  getResetLink: 'Saa lähtestamise link',
  goodbye: 'Nägemist!',
  inappropriateWordsNotAllowed: 'Solvavad sõnad ja fraasid ei ole lubatud',
  informationAndPromotionalAgreement:
    'Olen nõus saama informatsiooni ja turunduspakkumisi OlyBetilt kontaktandmetele, mida olen siin jaganud. Seda nõusolekut saan igal hetkel tagasi võtta, klikkides iga turundussõnumi lõpus olevale lingile. Rohkem infot andmetöötluse kohta leiab Privaatsuspoliitikast.',
  inOrderToPlayAndRedeemPrizes:
    'Mängimiseks ja auhindade saamiseks peavad olema teie andmed täpsed ja kinnitatud. Mõned auhinnad makstakse välja OlyBeti kontole ja nende kättesaamiseks peavad OlyBeti konto andmed ühtima Mängutsoonis registreeritud andmetega (nimi ja e-mail).',
  invalidCredentials: 'Valed andmed',
  invalidEmailFormat: 'Invalid email format',
  itIsRequiredField: 'See on kohustuslik väli',
  joinNow: 'Liitu nüüd',
  lastName: 'Perekonnanimi',
  laststNameIsRequired: 'Perekonnanimi on kohustuslik väli',
  laststNameMusBeAtLeast:
    'Perekonnanimi peab sisaldama vähemalt kolme tähemärki',
  laststNameMustNotExceed: 'Perekonnanimi ei tohi ületada sadat tähemärki',
  legalConsent: 'Juriidiliste dokumentide nõusolek',
  lines: 'RIDU',
  live: 'LIVE',
  liveGames: 'Live mängud',
  login: 'Login',
  marketingConsent: 'Turunduse nõusolek',
  mobileNumber: 'Mobiilinumber',
  mobileNumberIsRequired: 'Mobiilinumber on kohustuslik väli',
  mobileNumberMustBeAtLeast:
    'Mobiilinumber peab sisaldama vähemalt kuute tähemärki',
  mobileNumberMustNotExceed:
    'Mobiilinumber ei tohi ületada viiteteist tähemärki',
  mustBeChecked: 'Peab üle kontrollima',
  mustContainFrom8To20Characters: 'Must contain from 8 to 20 characters',
  mustContainOneLowercase: 'Must contain at least one lowercase',
  mustContainOneNumber: 'Must contain at least one number',
  mustContainOneUppercase: 'Must contain at least one uppercase',
  myContest: 'Minu võistlused',
  myHistory: 'Minu ajalugu',
  nationality: 'Rahvus',
  newPassword: 'Uus parool',
  newPasswordIsRequired: 'Uus parool on kohustuslik väli',
  nickname: 'Hüüdnimi',
  nicknameAlredyInUse: 'Hüüdnimi on juba kasutusel',
  nicknameIsRequired: 'Hüüdnimi on kohustuslik väli',
  noHistoryYet: 'Ajalugu ei ole',
  noUpcomingContestsYet: 'Eesolevaid võistlusi ei ole',
  oops: 'Ups! Midagi läks valesti...',
  over$PrizeValueWon: 'Over <1>$1,000,000</1> prize value won',
  password: 'Parool',
  passwordDoNotMatch: 'Paroolid ei klapi',
  passwordIsRequired: 'Parool on kohustuslik väli',
  passwordNotMeetCriteria: 'Parool ei vasta tingimustele',
  passwordSuccessfullyReset: 'Parool edukalt uuendatud',
  personalDetails: 'Personaalsed detailid',
  playNow: 'Mängi kohe',
  pleaseCheckYourEmailInbox: 'Palun kontrolli oma emaili',
  pos: 'Pos.',
  preferences: 'Eelistused',
  profile: 'Profiil',
  pts: 'PTS',
  recentWinners: 'Hiljutised võitjad',
  region: 'Piirkond',
  resetLinkSent: 'Lähtestamise link saadetud',
  resetPassword: 'Taasta parool',
  resubscribe: 'Lisa mind listi',
  returnToLogin: 'Return to login',
  saveChanges: 'Salvesta muudatused',
  signIn: 'Logi sisse',
  success: 'Toimis!',
  successfullyLoggedIn: 'Edukalt sisse logitud',
  successfullySentResetLink: 'Lähtestamise link edukalt saadetud emailile',
  successfullySignedUp: 'Registreerumine õnnestus!',
  successfullySubscribed: 'Successfully subscribed',
  successfullyUnsubscribed: 'Edukalt maharegistreeritud',
  successfullyUpdatedProfile: 'Profiil edukalt uuendatud',
  unsubscribe: 'Loobu teavitustest',
  upload: 'Lae üles',
  username: 'Kasutajanimi',
  usernameAlreadyInUse: 'Kasutajanimi on juba kasutusel. Proovi uuesti.',
  usernameIsRequired: 'Username is a required field',
  veryStrongPassword: 'Very strong password',
  welcomeBack: 'Tere tulemast tagasi!',
  win: 'VÕIT',
  winner: 'Võitja',
  winPrizes: 'MÄNGU JOOKSUL RIDADE TÄIS SAAMISEL VÕIDAD AUHINDU.',
  youHaveSuccesfullyUnsubscribed: 'Oled edukalt listist eemaldatud.',
  yourEmail: 'Your e-mail',
  youWishToUnsubscribe: 'Vajuta nupule, et OlyBeti turundussõnumitest loobuda.',
  zipCode: 'Postiindeks',
  zipCodeIsRequired: 'Postiindeks on kohustuslik väli',
  zipCodeMustBeAtLeast: 'Postiindeks peab sisaldama vähemalt kolme tähemärki',
  zipCodeMustNotExceed: 'Postiindeks ei tohi ületada kümmet tähemärki',
};
export default translation;
